import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { NOTIFICATION_PREFERENCES_URL } from '../constants/urls';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DueDateReminderTooltipContent = () => /*#__PURE__*/_jsxs(View, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.dueDate.reminderTooltipHeading"
  }), /*#__PURE__*/_jsxs(List, {
    styled: true,
    children: [/*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.dueDate.reminderTooltipItems.beforeDueDate"
      })
    }), /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.dueDate.reminderTooltipItems.onDueDate"
      })
    }), /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.dueDate.reminderTooltipItems.oneDayAfter"
      })
    })]
  }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "productApprovals.dueDate.reminderTooltipFooter_jsx",
    elements: {
      Link
    },
    options: {
      external: true,
      href: NOTIFICATION_PREFERENCES_URL
    }
  })]
});
export const DueDateReminderTooltip = () => /*#__PURE__*/_jsx(HelpIcon, {
  title: /*#__PURE__*/_jsx(DueDateReminderTooltipContent, {}),
  tooltipProps: {
    use: 'longform'
  }
});